import type { SVGProps } from "react";
const SvgArrowLeft02Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M4.167 10h12.5M7.5 5.833 3.922 9.411c-.277.277-.416.416-.416.589 0 .172.139.311.416.59L7.5 14.166"
    />
  </svg>
);
export default SvgArrowLeft02Sharp;
